import PasswordCheck from "./src/passwordcheck/index"
import UnoCaptcha from "./src/unocaptcha/index"
import UnoUtil from "./src/util/index"
import MessageComponent from "./src/util/MessageComponent"
import EaseContactInfo from "./src/util/EaseContactInfo"
import AlertComponent from "./src/util/AlertComponent"
import CxAlertComponent from "./src/util/CxAlertComponent"
import ProcessingComponent from "./src/util/ProcessingComponent"
import ProcessingOverlayComponent from "./src/util/ProcessingOverlayComponent"
import {userData} from "./src/userdata";

const UnoSecurityCommon = {
    PasswordCheck,
    UnoCaptcha,
    Util: UnoUtil
};

export default UnoSecurityCommon;
export {PasswordCheck, UnoCaptcha, UnoUtil, MessageComponent, EaseContactInfo, AlertComponent, CxAlertComponent,
    ProcessingComponent, ProcessingOverlayComponent, userData
};
